import type { ReactNode } from 'react';

export interface LwMetricCardProps {
  label: ReactNode;
  value: ReactNode;
  caption?: ReactNode;
  icon?: ReactNode;
  className?: string;
}

export function LwMetricCard({ label, value, caption, icon, className }: LwMetricCardProps) {
  return (
    <article className={`lw-metric-card${className ? ` ${className}` : ''}`}>
      <div className="lw-metric-card__head">
        <div className="lw-caps-label">{label}</div>
        {icon && <span className="lw-metric-card__icon" aria-hidden="true">{icon}</span>}
      </div>
      <div className="lw-metric-card__value">{value}</div>
      {caption && <div className="lw-metric-card__caption">{caption}</div>}
    </article>
  );
}
